import {createAction} from 'typesafe-actions';

import * as Types from './types';

export const setGroupSelections = createAction(
  '@view/groupSelections/setGroupSelections',
  action => (ref: Types.Ref, groupSelections: Types.GroupSelections) =>
    action({ref, groupSelections})
);
